import { ChevronDown, Database, X } from 'lucide-react'
import { useState } from 'react'
import { Link, Outlet } from 'react-router-dom'

import { MobileNavigation, SidebarNavigation } from './navigation'

export function AppShell() {
  const [isStudentMenuOpen, setIsStudentMenuOpen] = useState(false)

  return (
    <div className="app-shell">
      <a className="skip-link" href="#main-content">
        跳到主要内容
      </a>
      <SidebarNavigation />

      <div className="app-shell__content">
        <header className="topbar">
          <div className="topbar__date">2026年7月14日 · 暑期学习计划</div>
          <div className="topbar__actions">
            <span className="sync-status">
              <Database size={15} strokeWidth={1.7} aria-hidden="true" />
              本地数据
            </span>
            <div className="student-identity">
              <span className="avatar" aria-hidden="true">
                S
              </span>
              <span>STUDENT_001</span>
            </div>
          </div>
        </header>

        <header className="mobile-header">
          <Link to="/today" className="mobile-header__brand">
            stuDNA
          </Link>
          <span className="mobile-header__date">7月14日</span>
          <button
            type="button"
            className="mobile-header__profile"
            aria-label="打开学生菜单"
            aria-expanded={isStudentMenuOpen}
            onClick={() => setIsStudentMenuOpen((current) => !current)}
          >
            <span className="avatar" aria-hidden="true">
              S
            </span>
            {isStudentMenuOpen ? (
              <X size={18} aria-hidden="true" />
            ) : (
              <ChevronDown size={18} aria-hidden="true" />
            )}
          </button>
          {isStudentMenuOpen ? (
            <nav className="mobile-profile-menu" aria-label="更多页面">
              <Link to="/assessments" onClick={() => setIsStudentMenuOpen(false)}>
                题库与测评
              </Link>
              <Link to="/reports" onClick={() => setIsStudentMenuOpen(false)}>
                学习报告
              </Link>
              <Link to="/parent" onClick={() => setIsStudentMenuOpen(false)}>
                家长视图
              </Link>
            </nav>
          ) : null}
        </header>

        <main id="main-content" className="main-content">
          <Outlet />
        </main>
      </div>

      <MobileNavigation />
    </div>
  )
}
